/* CW Uhren-Ankauf: ersetzt Hulks abgeschnittenes Advanced JS durch einen kleinen Asset-Loader. */
(function () {
  if (!/(^|\/)pages\/uhren-ankauf\/?$/.test(window.location.pathname)) {
    return;
  }

  var FORM_ID = 'Z3I3t3m344jsxhh3wkw9_g';
  var hulkFormBuilder = window.hulkFormBuilder;
  var forms = hulkFormBuilder && hulkFormBuilder.form_data;
  var formEntry = forms && forms['form_' + FORM_ID];
  var formData = formEntry && formEntry.form_data;

  if (!formData) {
    return;
  }

  function isEnglishPage() {
    return /(^|\/)en(\/|$)/.test(window.location.pathname);
  }

  function applyEnglishFormCopy() {
    if (!isEnglishPage()) {
      return;
    }

    formData.form_submit = 'Submit';
    formData.after_submit_msg = '<p>Thank you for your inquiry. Our team will contact you shortly.</p>';

    (formData.formElements || []).forEach(function (field) {
      if (!field) {
        return;
      }

      if (field.label === 'Vorname') field.label = 'First name';
      if (field.label === 'Nachname') field.label = 'Last name';
      if (field.label === 'E-Mail-Adresse') field.label = 'Email address';
      if (field.label === 'Telefon') field.label = 'Phone';
      if (field.label === 'Modell- und Referenznummer') field.label = 'Model and reference number';
      if (field.label === 'Preisvorstellung') field.label = 'Expected price';
      if (field.label === 'Beschreibung') field.label = 'Description';
      if (field.label === 'Fotos hinzufügen') field.label = 'Add photos';
      if (field.label === 'Wie sind sie auf unsere Ankaufseite aufmerksam geworden?') field.label = 'How did you hear about our purchase page?';
      if (field.label === 'Datenschutzerklärung akzeptieren') field.label = 'Accept privacy policy';
      if (field.label === 'Einwilligung zur Kontaktaufnahme') field.label = 'Consent to be contacted';

      if (field.sublabel === 'Sie können bis zu 10 Bilder hochladen') field.sublabel = 'You can upload up to 10 images';
      if (field.browse_btn === 'Bilder auswählen') field.browse_btn = 'Select images';

      if (field.infoMessage && field.infoMessage.indexOf('Bitte geben Sie hier eine kurze Beschreibung ein') !== -1) {
        field.infoMessage = 'Please enter a short description, for example condition, age, original accessories (box and papers) – if known.';
      }
      if (field.infoMessage && field.infoMessage.indexOf('Ihre Bilder helfen uns bei einer genauen Einschätzung') !== -1) {
        field.infoMessage = 'Your photos help us make an accurate assessment. Allowed file formats: JPG, JPEG, PNG, SVG – up to 10 images.';
      }
      if (field.infoMessage && field.infoMessage.indexOf('Ich willige ein, dass meine Angaben') !== -1) {
        field.infoMessage = 'I agree that my details may be processed to handle my request in accordance with the privacy policy. Your data will only be used for this request and will not be shared with third parties.';
      }
      if (field.infoMessage && field.infoMessage.indexOf('Ich bin damit einverstanden, dass Sie mich') !== -1) {
        field.infoMessage = 'I agree that you may contact me by phone or email to process my request.';
      }

      if (field.values) {
        field.values = field.values
          .replace('Empfehlung', 'Recommendation')
          .replace('Direkt über unsere Website', 'Directly via our website')
          .replace('Online-Werbung', 'Online advertising')
          .replace('Keine Angabe', 'No answer');
      }
    });

    var shopMessages = hulkFormBuilder && hulkFormBuilder.settings_data && hulkFormBuilder.settings_data.shop_settings && hulkFormBuilder.settings_data.shop_settings.shop_customise_msgs && hulkFormBuilder.settings_data.shop_settings.shop_customise_msgs[0];

    if (shopMessages) {
      shopMessages.processing = 'Processing...';
      shopMessages.is_required = 'Is required';
      shopMessages.valid_data = 'Please enter valid data';
      shopMessages.valid_email = 'Please enter a valid email address';
      shopMessages.valid_phone = 'Please enter a valid phone number';
      shopMessages.error_form_submit = 'Error submitting the form';
      shopMessages.email_submitted = 'Email has already been submitted';
      shopMessages.please_select = 'Please select';
      shopMessages.your_response = 'Your response';
      shopMessages.submission_no = 'Submission number';
      shopMessages.referral_url = 'Referrer URL';
    }
  }

  function postIframeCopyPatch() {
    if (!isEnglishPage()) {
      return;
    }

    var scope = '.hulk_form_' + FORM_ID;
    var cssPatch = [
      scope + ' .formElement_0,',
      scope + ' .formElement_1,',
      scope + ' .formElement_2,',
      scope + ' .formElement_4,',
      scope + ' .formElement_6{position:relative!important;}',
      scope + ' .formElement_0 input::placeholder,',
      scope + ' .formElement_1 input::placeholder,',
      scope + ' .formElement_2 input::placeholder,',
      scope + ' .formElement_4 input::placeholder,',
      scope + ' .formElement_6 textarea::placeholder{color:transparent!important;opacity:0!important;}',
      scope + ' .formElement_0 .block_label,',
      scope + ' .formElement_1 .block_label,',
      scope + ' .formElement_2 .block_label,',
      scope + ' .formElement_4 .block_label,',
      scope + ' .formElement_6 .block_label,',
      scope + ' .formElement_9 legend,',
      scope + ' .formElement_11 label[for="Checkbox11"],',
      scope + ' .formElement_13 label[for="Checkbox13"]{font-size:0!important;}',
      scope + ' .formElement_0 .block_label,',
      scope + ' .formElement_1 .block_label,',
      scope + ' .formElement_2 .block_label,',
      scope + ' .formElement_4 .block_label,',
      scope + ' .formElement_6 .block_label{display:block!important;position:absolute!important;z-index:2;left:24px!important;top:50%!important;transform:translateY(-50%)!important;pointer-events:none!important;color:#707070!important;line-height:1!important;margin:0!important;padding:0!important;}',
      scope + ' .formElement_6 .block_label{top:20px!important;transform:none!important;}',
      scope + ' .formElement_0:focus-within .block_label,',
      scope + ' .formElement_1:focus-within .block_label,',
      scope + ' .formElement_2:focus-within .block_label,',
      scope + ' .formElement_4:focus-within .block_label,',
      scope + ' .formElement_6:focus-within .block_label,',
      scope + ' .formElement_0:has(input:not(:placeholder-shown)) .block_label,',
      scope + ' .formElement_1:has(input:not(:placeholder-shown)) .block_label,',
      scope + ' .formElement_2:has(input:not(:placeholder-shown)) .block_label,',
      scope + ' .formElement_4:has(input:not(:placeholder-shown)) .block_label,',
      scope + ' .formElement_6:has(textarea:not(:placeholder-shown)) .block_label{display:none!important;}',
      scope + ' .formElement_0 .block_label::after{content:"First name *";font-size:15px!important;}',
      scope + ' .formElement_1 .block_label::after{content:"Last name *";font-size:15px!important;}',
      scope + ' .formElement_2 .block_label::after{content:"Email address *";font-size:15px!important;}',
      scope + ' .formElement_4 .block_label::after{content:"Model and reference number *";font-size:15px!important;}',
      scope + ' .formElement_6 .block_label::after{content:"Description *";font-size:15px!important;}',
      scope + ' .formElement_9 legend::after{content:"How did you hear about our purchase page? *";font-size:15px!important;}',
      scope + ' .formElement_11 label[for="Checkbox11"]::after{content:"Accept privacy policy *";font-size:15px!important;}',
      scope + ' .formElement_13 label[for="Checkbox13"]::after{content:"Consent to be contacted *";font-size:15px!important;}',
      scope + ' .formElement_6 .infoMessage{font-size:0!important;}',
      scope + ' .formElement_6 .infoMessage::after{content:"Please enter a short description, for example condition, age, original accessories (box and papers) – if known.";font-size:13px!important;line-height:1.5!important;}'
    ].join('');
    var payload = JSON.stringify([{
      form_uuid: FORM_ID,
      form_settings: 'true',
      fill_color: 'transparent',
      padding: '24',
      border_color: '#c7c7c7',
      border_radius: '0',
      border: '0',
      form_width: '668',
      fonts: 'Barlow, sans-serif',
      font_color: '#2e2e2e',
      size: '15',
      btn_text: 'Submit',
      sub_btn_bg_color: '#000000',
      sub_btn_txt_color: '#ffffff',
      sub_btn_bdr_rad: '0',
      sub_btn_font_size: '13',
      sub_btn_bdr_width: '0',
      sub_btn_bdr_color: '#000000',
      input_font_color: '#2e2e2e',
      input_size: '15',
      input_background_color: '#ffffff',
      input_border_radius: '0',
      input_border_color: '#dfdfe9',
      input_background_color_focus: '#ffffff',
      input_border_color_focus: '#cccccc !important;} ' + cssPatch + ' /*'
    }]);

    function send() {
      var iframes = document.querySelectorAll('iframe[src*="formbuilder.hulkapps.com/corepage/customform"][src*="' + FORM_ID + '"]');
      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].contentWindow) {
          iframes[i].contentWindow.postMessage(payload, 'https://formbuilder.hulkapps.com');
        }
      }
    }

    var tries = 0;
    send();
    var timer = window.setInterval(function () {
      send();
      tries += 1;
      if (tries > 80) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  applyEnglishFormCopy();

  var assetUrl = 'https://www.colognewatch.de/cdn/shop/t/137/assets/cw-hulk-watch-purchase-form-locale-20260518.js';

  try {
    if (document.currentScript && document.currentScript.src) {
      assetUrl = new URL('cw-hulk-watch-purchase-form-locale-20260518.js', document.currentScript.src).toString();
    }
  } catch (error) {}

  assetUrl = assetUrl.split('?')[0];
  assetUrl += '?cw_v=20260518-watch-purchase-en-form-copy-fix-v2';

  formData.advance_js = '(function(){var s=document.createElement("script");s.src=' + JSON.stringify(assetUrl) + ';document.head.appendChild(s);}());';
  postIframeCopyPatch();
})();
